<template>
    <div class="lp_list">
      <div class="title"  v-if="isShowTitle">
        <slot name="title">共<span>{{total}}</span>家企业</slot>
      </div>
      <div class="list" v-if="dataList.length>0">
        <div class="item" v-for="(item,index) in dataList" :key="index" @click="itemClick(item,index)">
          <img :src="item.logo || require('../../assets/images/noPic.png')" alt="" class="left">
          <!-- <div class="left" :style="`background:url(${item.logo}) no-repeat center center;background-size:100%,auto`"></div> -->
          <div class="right">
            <div class="name">{{ item.institutionName }}</div>
            <p><span>{{ item.serverTypeName }}</span></p>
            <p>地址：{{ item.address }}</p>
            <p v-if="item.brief">{{ item.brief.replace(/<\/?.+?\/?>/g,'').replace(/\&.+\;/mg,'') }}</p>
          </div>
        </div>
      </div>

      <lp-empty v-else></lp-empty>
    </div>
</template>

<script>
  export default {
    name: "lp_list",
    props:{
      total:{//总数
        type:Number,
        default:0
      },
      isShowTitle:{
        type:Boolean,
        default:true
      },
      //数据
      dataList:{
        type:Array,
        default:()=>[]
      }
    },
    data () {
      return{

      }
    },
    methods: {
      //点击item
      itemClick(item,index){
        this.$emit('itemClick',item,index);
      }
    },
  }
</script>

<style scoped lang="less">
.lp_list{
 .title{
    width: 100%;
    padding: 22px 30px;
    box-sizing: border-box;
    font-family: MicrosoftYaHei;
    font-size: 12px;
    color: #324059;
    letter-spacing: 0;
    border-bottom: 1px solid  #E5E5E5;
    span{
      font-size: 14px;
      color: #151515;
      letter-spacing: 0;
      font-weight: bold;
      margin: 0 4px;
    }
  }
  .list{
    width: 100%;
    height: auto;
    .item{
      width: 100%;
      padding:24px 30px;
      box-sizing: border-box;
      border-bottom: 1px solid #E5E5E5;
      display: flex;
      cursor: pointer;
      .left{
        width: 108px;
        height: 108px;
        border: 1px solid #D8D8D8;
        box-sizing: border-box;
      }
      .right{
        flex: 1;
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        .name{
          font-family: MicrosoftYaHei-Bold;
          font-size: 16px;
          color: #333333;
          letter-spacing: 0;
          font-weight: bold;
        }
        p{
          width: 100%;
          word-break: break-all;
        }
        p:nth-of-type(1){
          span{
            display: inline-block;
            background: rgba(24,144,255,0.1);
            margin-top: 7px;
            padding: 5px 8px;
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #1890FF;
            letter-spacing: 0;
          }
        }
        p:nth-of-type(2){
          margin-top: 20px;
          font-family: MicrosoftYaHei;
          font-size: 12px;
          color: #333333;
          letter-spacing: 0;
        }
        p:nth-of-type(3){
          margin-top: 10px;
          font-family: MicrosoftYaHei;
          font-size: 12px;
          color: #666666;
          letter-spacing: 0;
          line-height: 18px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/list/index.vue